import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;

  ${({ theme: { spacing } }) => `
    gap: ${spacing.level5};
    padding: ${spacing.level5};
  `}
`;

export const AppRunReturn = styled.div`
  flex: none;
  background: ${({ theme }) => theme.colors.surface};
`;

export const AppRunReturnInner = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: ${({ theme: { spacing } }) => `${spacing.level3} ${spacing.level5} 0`};

  @media (max-width: 768px) {
    padding: ${({ theme: { spacing } }) => `${spacing.level3} ${spacing.level3} 0`};
  }
`;

export const BackToApp = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: -4px;
  padding: 2px 6px 2px 4px;
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.surfaceContainer};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;
